<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('price.exportPrices') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="contractor-prices-export-form" tag="form">
          <div class="form-group">
            <label for="name">
              {{ $t('settings.currency.currency') }}:
            </label>

            <validation-provider
              rules="required"
              name="currency-id"
              v-slot="{ errors }">
              <d-form-select
                v-model="currency_id"
                :state="errors.length ? 'invalid' : null"
                :options="currenciesOptions" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="exportInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="exportInProgress"
        @click.prevent="validateForm">
        <div
          v-if="exportInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('price.export') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import CommonGetters from './../../utils/CommonGetters.js';
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'contractor-prices-export-popup',
  props: {
    contractorId: {
      default: 0,
      type: Number
    },
    currencies: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    currenciesOptions () {
      return CommonGetters.getCurrenciesForSelect(this.currencies);
    }
  },
  data () {
    return {
      currency_id: 0,
      exportInProgress: false
    };
  },
  mounted () {
    this.currency_id = this.currencies[0].id;
    this.exportInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('contractor-prices-export-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['contractor-prices-export-form'], this.export);
    },
    export () {
      this.exportInProgress = true;

      this.$http.post('/contractors/prices/export/' + this.contractorId, {
        currency_id: this.currency_id
      }, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.$t('price.supplierPricesFileNamePrefix') + this.contractorId + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.cancel();
        this.exportInProgress = false;

        Vue.swal({
          title: this.$t('price.exportSuccessfull'),
          html: this.$t('price.exportSuccessfullDesc'),
          type: 'success',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true,
          timer: 2000
        });
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.exportErrorTitle'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.exportInProgress = false;
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
